import { mapEquipmentStateIssue } from './prodEquipmentStateCatalogMappers';
import type {
  EquipmentStateCatalogClientError,
  EquipmentStateCatalogRequestFailure,
} from '../types/prodEquipmentStateCatalog';

type RawRecord = Record<string, unknown>;

const asRecord = (value: unknown): RawRecord => (
  value && typeof value === 'object' ? value as RawRecord : {}
);

const asFiniteNumber = (value: unknown): number | null => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const normalizeEquipmentStateCatalogError = (error: unknown): EquipmentStateCatalogClientError => {
  const rawError = asRecord(error);
  const response = asRecord(rawError.response);
  const status = asFiniteNumber(response.status);
  const body = asRecord(response.data);
  const details = asRecord(body.details);
  const code = typeof body.code === 'string' ? body.code : '';
  const fallbackMessage = typeof body.message === 'string' && body.message
    ? body.message
    : error instanceof Error ? error.message : '设备状态机请求失败';
  const message = code === 'STATE_CYCLE_POLICY_LEGACY_REVIEW_REQUIRED'
    ? '旧周期策略不能自动转换，请在新草稿中按计时启动、周期推进和到期判定三部分人工复核。'
    : fallbackMessage;

  if (status === 409 && code.includes('REVISION_CONFLICT')) {
    return {
      kind: 'revision-conflict',
      message,
      expectedRevision: asFiniteNumber(details.expectedRevision ?? details.expected_revision),
      actualRevision: asFiniteNumber(
        details.currentRevision ?? details.current_revision ?? details.actualRevision ?? details.actual_revision,
      ),
    };
  }

  const rawIssues = Array.isArray(details.issues)
    ? details.issues
    : details.issue ? [details.issue] : [];
  const failure: EquipmentStateCatalogRequestFailure = {
    kind: 'request-failure',
    message,
    status,
    issues: rawIssues.map(mapEquipmentStateIssue),
  };
  return failure;
};
